import styled from 'react-emotion'

export const A = styled('a')({
  color: '#160A2E'
})
